// Path utility class - updated with better string conversion
export class PathBuilder {
	private path: string
	constructor(initialPath = "") {
		this.path = initialPath
	}

	// Join path segments and return a new PathBuilder instance
	static Join(...segments: string[]): PathBuilder {
		// Filter out empty segments
		const filteredSegments = segments.Filter((s) => !!s)

		// Process each segment to remove leading and trailing slashes
		const processedSegments = filteredSegments.Map((s) => {
			// Handle string conversion for any object
			const str = String(s)
			// Remove leading slashes
			let processed = str.HasPrefix("/") ? str.substring(1) : str
			// Remove trailing slashes
			processed = processed.HasSuffix("/")
				? processed.substring(0, processed.length - 1)
				: processed
			return processed
		})

		// Join with single slashes
		const joined = "/" + processedSegments.Join("/")

		// Handle any consecutive slashes that might still exist
		const cleanPath = joined.Replace(/\/+/g, "/")

		return new PathBuilder(cleanPath)
	}

	// Create parametrized path segment
	static Param(name: string): string {
		return `{${name}}`
	}

	// Replace a parameter in the path and return this instance for chaining
	Replace(paramName: string, value: string): PathBuilder {
		this.path = this.path.Replace(`{${paramName}}`, value)
		return this
	}

	// Convert to string
	String(): string {
		return this.path
	}

	// Alternative ToString for Go style

	// Make sure this object can be coerced to a string
	[Symbol.toPrimitive](hint: string): string | null {
		if (hint === "string" || hint === "default") {
			return this.path
		}
		return null
	}
}

export function Join(...segments: string[]): PathBuilder {
	return PathBuilder.Join(...segments)
}

export function Param(name: string): string {
	return PathBuilder.Param(name)
}
